import { render, staticRenderFns } from "./popup-sh-do.vue?vue&type=template&id=1274fb64&scoped=true"
import script from "./popup-sh-do.vue?vue&type=script&lang=js"
export * from "./popup-sh-do.vue?vue&type=script&lang=js"
import style0 from "./popup-sh-do.vue?vue&type=style&index=0&id=1274fb64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274fb64",
  null
  
)

export default component.exports